export const ROLE_LABELS = {
  super_admin: 'Super Admin',
  organization_head: 'Organization Head',
  admin: 'Admin',
  finance_manager: 'Finance Manager',
  accountant: 'Accountant',
  project_manager: 'Project Manager',
  employee: 'Employee',
  viewer: 'Viewer',
};

export const ROLE_HOME_ROUTES = {
  super_admin: '/super-admin',
  organization_head: '/dashboard',
  admin: '/dashboard',
  finance_manager: '/finance',
  accountant: '/accountant',
  project_manager: '/project-manager',
  employee: '/app',
  viewer: '/viewer',
};

export const resolveEffectiveRole = (userRole, orgRole) => {
  if (userRole === 'super_admin') return 'super_admin';
  if (orgRole && ROLE_HOME_ROUTES[orgRole]) return orgRole;
  if (userRole && ROLE_HOME_ROUTES[userRole]) return userRole;
  return 'employee';
};

export const roleLabel = (roleKey) => ROLE_LABELS[roleKey] || 'User';

export const roleHomeRoute = (roleKey) => ROLE_HOME_ROUTES[roleKey] || '/dashboard';
